<template>
  <div class="button-section-container">
    <div class="content-section">
      <ValidationObserver ref="observer">
        <v-form @submit.prevent="resetPassword()">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
          <ValidationProvider
            :id="whitelabel.authentication.resetPassword.fieldName"
            v-slot="{ errors }"
            :name="whitelabel.authentication.resetPassword.fieldName"
            :rules="whitelabel.authentication.resetPassword.validation"
          >
            <v-text-field
              v-model="uuid"
              :label="whitelabel.authentication.resetPassword.fieldTitle"
              :error-messages="
                errors.length
                  ? whitelabel.authentication.resetPassword.validationMessage
                  : null
              "
            />
          </ValidationProvider>
          <div class="signin-button">
            <GradientButton
              type="submit"
              :loading="resetPasswordButtonLoading"
              :small="true"
              :title="this.whitelabel.authentication.resetPassword.buttonText"
            />
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
  import SsoButton from '../guest/SsoButton.vue';
  import loginService from '../../services/LoginService';
  import { FORGOT_PASSWORD_MUTATION } from '../../constants/graphql/users';

  export default {
    name: 'ForgotPasswordEmail',
    props: {},
    components: {
      SsoButton,
    },
    methods: {
      resetPassword() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.resetPasswordButtonLoading = true;
            this.sendResetRequest();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      sendResetRequest() {
        this.$apollo
          .mutate({
            mutation: FORGOT_PASSWORD_MUTATION,
            variables: {
              authenticationValue: this.uuid,
              authenticationField:
                this.whitelabel.authentication.resetPassword.fieldName,
            },
          })
          .then(result => {
            this.resetPasswordButtonLoading = false;
            this.$emit('successResetPassword');
          })
          .catch(error => {
            this.resetPasswordButtonLoading = false;
            this.errorMessage = 'Something went wrong. Please try again.';
            throw error;
          });
      },
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.login();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      onError(error) {
        this.$emit('onError', error);
      },
      login() {
        const uniqueIdentifier = this.uniqueIdentifier;
        const password = this.password;
        loginService
          .login(
            this.uniqueIdentifier,
            this.password,
            this.$apollo,
            this.$store
          )
          .then(result => {
            if (result.message?.includes('GraphQL error')) {
              throw result;
            }
            const login = result.data.login;
            const accessToken = login.accessToken;
            const refreshToken = login.refreshToken;
            const testatorId = login.testatorId;
            const userId = login.userId;
            const willCountry = login.willCountry;
            const companyId = login.companyId;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
              companyId,
            });
            loginService.setSentryUser(userId);
            loginService.redirectToNext(this.$router);
          })
          .catch(error => {
            this.onError(error);
          });
      },
      forgotPassword() {
        this.$emit('forgotPassword');
      },
      handleEmailSignUp() {
        this.showContent = !this.showContent;
        this.$emit('onError', null);
      },
      submitClicked() {
        // Do Nothing as it needs to submit
      },
    },
    data() {
      return {
        uuid: '',
        showContent: false,
        uniqueIdentifier: this.prepopulatedEmail,
        password: null,
        errorMessage: null,
        showPassword: false,
        buttonLoading: false,
        resetPasswordButtonLoading: false,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .button-section-container {
    width: 100%;

    .button-section {
      margin-bottom: 24px;
      width: 100%;
    }
    .content-section {
      width: 100%;
      .signin-button {
        margin-top: 52px;
      }
      a {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        color: #282828;
      }

      .forgot-password {
        text-decoration: underline;
      }
    }
  }
</style>
